<svelte:options accessors/>
<script>
    import NauiTable from "../../naui/components/NauiTable.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiFloatingAction from "../../naui/components/NauiFloatingAction.svelte";
    import NauiTextarea from "../../naui/atoms/NauiTextarea.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher()

    export let tables = [];
    export let info = null;
    export let observaciones = '';

    function save(report) {
        const data = {
            observaciones,
            dias: info.data[0].cierre,
            tables: tables.map((table) => {
                return {
                    slug: table.slug,
                    items: [...table.items.map((item) => {
                        return {
                            slug: item.slug,
                            data: [...item.data]
                        }
                    })]
                };
            })
        }
        if (report) {
            data.action = report;
        }
        dispatch('save', data);
    }
</script>
<div>
    <div class="box-r sx-ii my-15">
        <NauiButton caption={info.salida ? 'REPORTAR SALIDA' : 'CAMBIAR ITEMS SALIDA'}
                    color="accent"
                    mode="stroked"
                    on:click={() => {save('report-used');}}/>
        {#if !info.salida}
        <NauiButton caption="REPORTAR CIERRE"
                    color="accent"
                    mode="stroked"
                    on:click={() => {save('report-closed');}}/>
        {/if}
        <NauiButton caption="GENERAR ORDEN DE SERVICIO"
                    color="accent"
                    mode="solid" on:click={() => {dispatch('order');}}/>
    </div>
    {#if info}
        <div class="py-15 mx-width-1000">
            <NauiTable columns="{info.columns || []}"
                       data="{info.data || []}"/>
        </div>
    {/if}

    {#each tables as table}
        <fieldset>
            <legend>{table.title}</legend>
            <div class="mx-width-1000">
                <table class="naui-table w-100">
                    {#each table.items as item}
                        <thead>
                        <tr>
                            {#each item.columns as col}
                                <th>
                                    <div>
                                        {col.label}
                                    </div>
                                </th>
                            {/each}
                        </tr>
                        </thead>
                        <tbody>
                        {#each item.data as i}
                            <tr>
                                {#each item.columns as col}
                                    <td>
                                        <div class="w-100">
                                            {#if col.type === 'text'}
                                                {i[col.slug]}
                                            {:else if col.type === 'input'}
                                                <input class="naui-input" type="number"
                                                       bind:value={i[col.slug]}>
                                            {/if}
                                        </div>
                                    </td>
                                {/each}
                            </tr>
                        {:else}
                            <tr>
                                <td colspan="{item.columns.length}">
                                    <div>
                                        <h2>No se han encontrado registros</h2>
                                    </div>
                                </td>
                            </tr>
                        {/each}
                        <tr>
                            <td colspan={item.columns.length}>
                                <div></div>
                            </td>
                        </tr>
                        </tbody>
                    {/each}
                </table>
            </div>
        </fieldset>
    {/each}

    <div class="my-2 mx-width-1000">
        <NauiTextarea label="Observaciones adicionales del servicio"
                      bind:value={observaciones}/>
    </div>
</div>

<NauiFloatingAction>
    <NauiButton caption="GUARDAR"
                icon="save"
                color="accent"
                mode="solid"
                on:click={() => {save()}}/>
</NauiFloatingAction>

<style>
    .mx-width-1000 {
        max-width: 1000px;
    }

    .item-table + .item-table {
        margin-top: 2rem;
    }
</style>